export default "__VITE_ASSET__c4af699f__"